import type { MagicSchoolUser } from '@magicschool/supabase/user';
import { getTeacherUrl } from '@magicschool/utils/nextjs/url';
import { isAtLeastRole } from './UserRole';

const teacherUrl = getTeacherUrl();
export const VERCEL_URL = new URL(teacherUrl).origin;

export const DEFAULT_MAX_TOKENS = 4096;

export const AUTO_JOIN_CODE_KEY = 'auto-join-code' as const;
export const OUTPUT_HISTORY_ENTRY_POINT_KEY = 'output-history' as const;

export const STUDENT_ROOM_AUTO_LOCALE = 'student-room-auto-locale' as const;
export const GENERATION_ID_HEADER = 'x-msai-generation-id';
export const THREAD_ID_HEADER = 'x-msai-thread-id';
export const MAGIC_SCHOOL_EMAIL_DOMAIN = '@magicschool.ai';

/** Returns true if the user's email belongs to MagicSchool staff and should bypass song limits and tool access restrictions. */
export function isMagicSchoolInternalEmail(email?: string | null): boolean {
  return email?.toLowerCase().endsWith(MAGIC_SCHOOL_EMAIL_DOMAIN) ?? false;
}

/**
 * MagicSchool staff = internal+ role AND an @magicschool.ai email. This is the predicate that grants
 * cross-org tool access for internal testing/support (EAS-365 migrated-chatbot flip + the page-load
 * path in tools/[slug]/actions.ts). Kept in one place so the page router, the tool-chat/v2 API, and
 * the demo/share route can never drift on who counts as staff — the parity the migrated flip relies on.
 * Deliberately stricter than the role-only cross-org viewing gate in getToolCustomizationByShareCode.
 */
export function isMagicSchoolStaff(user: Pick<MagicSchoolUser, 'user_role' | 'email'>): boolean {
  return isAtLeastRole(user.user_role, 'internal') && isMagicSchoolInternalEmail(user.email);
}
